import { Image } from 'antd';
import UnavailableImage from "../../../../assets/images/No_image_available.png"

const ImageHelp = ({fileSource, width}) => {
    return(
        <Image width={width} src={fileSource ? fileSource : UnavailableImage} />
    );
}

export default ImageHelp;
